import * as TwoFactorAuthSetupSteps from './TwoFactorAuthSetupSteps';
import * as TwoFactorAuthMethods from './TwoFactorAuthMethods';
const STEP_ORDER = [TwoFactorAuthSetupSteps.CHOOSE_METHOD, TwoFactorAuthSetupSteps.REGISTER_HUBSPOT_WITH_GA, TwoFactorAuthSetupSteps.VERIFY_GOOGLE_AUTHENTICATOR, TwoFactorAuthSetupSteps.REGISTER_SMS, TwoFactorAuthSetupSteps.REGISTER_WITH_HUBSPOT_APP, TwoFactorAuthSetupSteps.VERIFY_SMS, TwoFactorAuthSetupSteps.BACKUP_CODES, TwoFactorAuthSetupSteps.VERIFICATION_SUCCESSFUL];
export function indexOfStep(step) {
  return STEP_ORDER.indexOf(step);
}
export function getConfirmMethodStep(method, currentStep) {
  if (method === TwoFactorAuthMethods.SMS) {
    return indexOfStep(TwoFactorAuthSetupSteps.REGISTER_SMS);
  } else if (method === TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR) {
    return indexOfStep(TwoFactorAuthSetupSteps.REGISTER_WITH_HUBSPOT_APP);
  } else if (method === TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR) {
    return indexOfStep(TwoFactorAuthSetupSteps.REGISTER_HUBSPOT_WITH_GA);
  }
  return currentStep;
}
export default STEP_ORDER;